/**
 * The Cooperative nav icon is the app icon: a disc with an arch at the bottom (Figma `Icon / Cooperative` 3073:3267).
 * Not selected it is drawn in the current text colour, like the other nav icons; selected it is the app icon itself,
 * in its brand colours (the same in both themes).
 */
export default function CooperativeIcon({ filled, size = 26 }: { filled: boolean; size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 28 28" aria-hidden="true" data-testid={filled ? "cooperative-icon-filled" : "cooperative-icon-outline"}>
      {filled ? (
        <>
          <circle cx="14" cy="14" r="12" fill="#FFDA44" />
          <path d="M11 26V18a3 3 0 0 1 6 0v8" fill="#14171F" />
        </>
      ) : (
        <>
          <circle cx="14" cy="14" r="11" fill="none" stroke="currentColor" strokeWidth="2" />
          <path d="M11.5 24V17.5a2.5 2.5 0 0 1 5 0V24" fill="currentColor" />
        </>
      )}
    </svg>
  );
}
